
export enum OptimizerResultStatusCd {
	ERROR = 'Error',
	SUCCESS = 'Success',
	WARNING = 'Warning'}

